import { Component } from '@angular/core';
import { ModalsService } from 'app/shared/services/modals.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@Component({
  selector: 'modal-component',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  constructor(public modalsService: ModalsService, public ga: GoogleAnalyticsService) {}
}
